/* eslint-disable */
import React from "react";

/**
 * Generic content skeleton, styled to match the /admin/home dashboard
 * skeleton (card blocks + shimmer). Replaces the old CircularProgress spinner.
 * Renders a row of stat cards plus a table/content panel, which fits the
 * majority of the app's list pages. The shimmer is transform-based so it keeps
 * animating smoothly even while the main thread is busy loading data.
 */
function PageSkeleton({ cards = 4, rows = 7, cols = 5 }) {
  return (
    <div
      className="page-skeleton"
      aria-busy="true"
      aria-label="Loading"
      style={{ "--skel-cols": cols }}
    >
      {/* Stat cards row */}
      <div className="ps-cards">
        {Array.from({ length: cards }).map((_, i) => (
          <div key={i} className="ps-card">
            <span className="gskel ps-card__icon" />
            <div className="ps-card__body">
              <span className="gskel ps-card__label" />
              <span className="gskel ps-card__value" />
            </div>
          </div>
        ))}
      </div>

      {/* Content / table panel */}
      <div className="ps-panel">
        <div className="ps-panel__bar">
          <span className="gskel ps-panel__search" />
          <span className="gskel ps-panel__btn" />
        </div>

        <div className="ps-table">
          <div className="ps-row ps-row--head">
            {Array.from({ length: cols }).map((_, c) => (
              <span key={c} className="gskel ps-cell" />
            ))}
          </div>
          {Array.from({ length: rows }).map((_, r) => (
            <div key={r} className="ps-row">
              {Array.from({ length: cols }).map((_, c) => (
                <span key={c} className="gskel ps-cell" />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PageSkeleton;
